import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { TemplateGenerationSettingsComponent } from 'app/pages/TemplateGenerationSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_SEGMENT_MESSAGE_TYPE_FOCUS } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useTemplateMessageTypeFocusPage } from './hooks/useTemplateMessageTypeFocusPage';

const SegmentMessageConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useTemplateMessageTypeFocusPage();

  return (
    <>
      <Helmet>
        <title>Segment Message Type Focus</title>
        <meta
          name="description"
          content="Template generation settings for segment message type focus"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Segment Message Type Focus"
        headerSubtitle={
          hasDealer ? (
            <Typography variant="subtitle1" color="text.secondary">
              {dealerTitle ? `${dealerTitle} (${dealerId})` : dealerId}
            </Typography>
          ) : undefined
        }
        contentVariant="centered"
      >
        <TemplateGenerationSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  SegmentMessageConfigurationPage,
  CONFIGURE_RESOURCE_SEGMENT_MESSAGE_TYPE_FOCUS,
);
